export default __webpack_public_path__ + "3fe85d01456a4494ce5194ad1844f423.png";